import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import PhysicianForm from "./ConservativeCareForm";
const EditConservativeCare = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_ConservativeCare_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit CAIT SPECIALIST"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editConservativeCare"
        ModalName="Edit_ConservativeCare_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={
          Edit_ConservativeCare_Modal ? Edit_ConservativeCare_Modal : false
        }
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="conservativeCareList"
      >
        <PhysicianForm />
      </FormModal>
    </div>
  );
};

export default EditConservativeCare;
